import React, { useEffect, useState } from "react";
import axios from "axios";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import UploadFile from "../UploadFile/UploadFile";
import { Modal } from "../../shared/components/modal/Modal";

// THis is the functionality and calculations of the re-roof stuff.

const ReRoofing = (props) => {
  const {
    setReRoofAmount,
    reRoof,
    setReRoof,
    adderToggle,
    reRoofAmount,
    roofSqFt,
    setRoofSqFt,
    roofType,
    setRoofType,
    sheathing,
    setSheathing,
    roofImg,
    setRoofImg,
    auroraDesignId,
    projectID,
    edit,
    setRoofQuote,
    roofQuote,
    getRoofQuote,
    designId,
    financeId,
    adders,
    services,
    roofAge,
    utilityLocation,
    loanA,
    loanProducts,
    getRoofQuotesPerProject,
    dealerFee,
  } = props;

  const [internalView, setInternalView] = useState(false);
  // Allow external control of modal via props, fallback to internal state
  const view =
    props.isModalOpen !== undefined ? props.isModalOpen : internalView;
  const setView = props.setIsModalOpen || setInternalView;
  const [manualCost, setManualCost] = useState(false);
  const [shingleAmount, setShingleAmount] = useState(5.75);
  const [cash, setCash] = useState(false);
  const [loanId, setLoanId] = useState(0);
  const [loan, setLoan] = useState("");
  const [roofQuotes, setRoofQuotes] = useState("");
  const [wasteAmount, setWasteAmount] = useState(1.18);
  // const [roofQuote, setRoofQuote] = useState({ quoteId: 0, roofSqFt: 0, roofType: '' })

  //Prod
  const apiUrl = `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`;
  //Dev
  //const apiUrl = `https://dev.iondeveloper.com/api/proposal-dev/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`

  const roofPropUrl = `https://proposalist.iondeveloper.com/?proj_id=${projectID}#/roofProp/${roofQuote.roofQuoteId}`;

  // const auroraApiUrl = 'https://dev.iondeveloper.com/api/proposal/Aurora/auroraAPI.php'

  // const getRoofSummary = () => {
  //   axios.post(auroraApiUrl,
  //     {
  //       method: 'getRoofSummary',
  //       designId: auroraDesignId
  //     }).then((res, err) => {
  //       if (err) {
  //         console.log(res.data)
  //       }
  //       console.log(res.data.roofs)
  //       setRoofSqFt(res.data.roofs.area)
  //     })
  // }

  let filteredLoans = loanProducts.filter((loans) =>
    loans.loanName.includes("Home"),
  );
  let mappedLoans = filteredLoans.map((loans, i) => {
    let info = [
      +loans.loanId,
      loans.loanName,
      +loans.loanTerm,
      +loans.loanInterest,
      +loans.prePayment,
      +loans.postPayment,
      +loans.interestOnlyPayment,
      +loans.itc,
      +loans.specialPrice,
    ];
    return (
      <option key={i} value={info}>
        {`${loans.loanName} ${loans.loanTerm} year ${loans.loanInterest}%`}
      </option>
    );
  });

  let adderIds = [];

  if (adders) {
    for (let i = 0; i < adders.length; i++) {
      adderIds.push(adders[i].id);
    }
  }

  const addRoofOnlyProp = async (quoteId) => {
    try {
      const res = await axios.post(apiUrl, {
        method: "add_roof_only_prop",
        pid: projectID,
        fid: financeId,
        did: designId,
        quote_amount: reRoofAmount * dealerFee,
        Reroof_Quote_ID__c: quoteId,
        Roof_Type__c: roofType,
        Roof_Square_Footage__c: roofSqFt,
        adderIds: adderIds,
      });

      // console.log(res.data);
      await getRoofQuote();
      if (projectID) {
        await getRoofQuotesPerProject();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const addRoofQuote = async () => {
    try {
      const res = await axios.post(apiUrl, {
        method: "add_roof_quote",
        project_id: projectID,
        roof_sq_ft: roofSqFt,
        quote_amount: reRoofAmount,
        roof_type: roofType,
        loan_id: loan[0],
        sheathing: sheathing,
        roofImg: roofImg,
      });

      // console.log(res.data);
      await getRoofQuote();
      await addRoofOnlyProp(res.data.quoteId);
    } catch (error) {
      console.error(error);
    }
  };

  if (edit) {
    setLoan("");
  }

  useEffect(() => {
    if (reRoof > 0 || roofAge === "15 to 20 years" || roofAge === "20+ years") {
      // Auto-calculate amount, but don't auto-open modal since button is removed
      setReRoofAmount((shingleAmount * roofSqFt) / dealerFee);
    }
  }, [reRoof]);

  useEffect(() => {
    switch (utilityLocation) {
      case "Oregon": {
        setShingleAmount(6.5);
        break;
      }
      case "Illinois": {
        setShingleAmount(7);
        break;
      }
      case "Connecticut": {
        setWasteAmount(1.15);
        break;
      }
    }
  }, [utilityLocation]);

  const handleCloseModal = () => {
    setView(false);
  };
  useEffect(() => {
    if (+loanA[0] === 115) {
      setCash(true);
    }
  }, [loanA]);

  useEffect(() => {
    ///Right here are the magic numbers
    let amount;
    if (!manualCost) {
      if (reRoof !== 1) {
        if (reRoof === 2) {
          // Architectural Shingle
          amount = shingleAmount;
        } else if (reRoof === 3) {
          // Tile
          amount = 10.75;
        } else if (reRoof === 4) {
          // Metal: Standing Seam
          amount = 8;
        } else if (reRoof === 5) {
          // Metal: Standing Seam
          amount = 9.75;
        } else if (reRoof === 6) {
          // Flat: (not tar or gravel)
          amount = 9.25;
        }
        if (["Oregon", "Illinois"].includes(utilityLocation)) {
          amount = amount + 0.75;
        }
        if (sheathing) {
          return setReRoofAmount(
            (amount * (roofSqFt * wasteAmount) + (roofSqFt / 32) * 80) /
              +dealerFee,
          );
        } else {
          return setReRoofAmount(
            (amount * (roofSqFt * wasteAmount)) / +dealerFee,
          );
        }
      }
    }
  }, [reRoof, reRoofAmount, roofSqFt, manualCost, dealerFee, sheathing]);

  return (
    <>
      <Modal
        isOpen={view}
        onClose={handleCloseModal}
        title={edit !== false ? "Re-roof" : "Roofing Only Quote"}
        className="large"
      >
        <div>
          <FormGroup row>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  size="small"
                  checked={sheathing}
                  onChange={(e) => adderToggle(sheathing, setSheathing)}
                  name="sheathing"
                />
              }
              label="Sheathing"
              labelPlacement="start"
            />
          </FormGroup>
          <hr className="mt-2 mb-2"></hr>

          <div>
            <div>
              <input
                className="form-check-input me-2"
                type="radio"
                name="reRoof"
                onChange={(e) => {
                  setReRoof(2);
                  setRoofType("Architectural Shingle");
                }}
                checked={reRoof === 2 ? "checked" : ""}
              />
              <span>Architectural Shinglesssssss</span>
            </div>
            <div>
              <input
                className="form-check-input me-2"
                type="radio"
                name="reRoof"
                onChange={(e) => {
                  setReRoof(3);
                  setRoofType("Tile");
                }}
                checked={reRoof === 3 ? "checked" : ""}
              />
              <span>Tile</span>
            </div>
            <div>
              <input
                className="form-check-input me-2"
                type="radio"
                name="reRoof"
                onChange={(e) => {
                  setReRoof(5);
                  setRoofType("Metal: Standing Seam");
                }}
                checked={reRoof === 5 ? "checked" : ""}
              />
              <span>Metal: Standing Seam</span>
            </div>
            <div>
              <input
                className="form-check-input me-2"
                type="radio"
                name="reRoof"
                onChange={(e) => {
                  setReRoof(6);
                  setRoofType("Flat: (not tar or gravel)");
                }}
                checked={reRoof === 6 ? "checked" : ""}
              />
              <span>Flat: (not tar or gravel)</span>
            </div>
            <div>
              <input
                className="form-check-input me-2"
                type="radio"
                name="reRoof"
                onChange={(e) => setReRoof(1)}
                checked={reRoof === 1 ? "checked" : ""}
              />
              <span>Third Party</span>
            </div>
          </div>
          <hr className="mt-2 mb-2"></hr>
          <div>
            <button
              className={
                manualCost ? "btn btn-primary" : "btn btn-outline-secondary"
              }
              onClick={() => setManualCost(!manualCost)}
            >
              Manual Cost
            </button>
          </div>
          {manualCost ? (
            <input
              className="form-control w-50"
              placeholder="Quoted amount"
              onChange={(e) =>
                setReRoofAmount((+e.target.value / +dealerFee).toFixed(2))
              }
            ></input>
          ) : (
            ""
          )}
          <div className="mt-2">
            <button
              className={cash ? "btn btn-primary" : "btn btn-outline-secondary"}
              onClick={() => {
                setCash(!cash);
                setLoan(0);
              }}
            >
              Cash
            </button>
          </div>
          {edit === false && !cash ? (
            <select
              className="form-control w-50"
              onChange={(e) => setLoan(e.target.value.split(","))}
            >
              <option style={{ display: "none" }}>Select Loan</option>
              {mappedLoans}
            </select>
          ) : (
            <></>
          )}
          {reRoof === 1 ? (
            <input
              className="form-control w-50"
              placeholder="Quoted amount"
              onChange={(e) =>
                setReRoofAmount((+e.target.value / +dealerFee).toFixed(2))
              }
            ></input>
          ) : (
            <>
              <hr className="mt-2 mb-2"></hr>
              <span>
                <b>Current Roof Sq Footage: </b> {roofSqFt}
              </span>
              <br></br>
              <input
                className="form-control w-50"
                placeholder={roofSqFt ? "Update Sq Ft" : "Roof Sq Ft Amount"}
                onChange={(e) => setRoofSqFt(+e.target.value)}
              ></input>
            </>
          )}
          {edit !== false || +reRoof < 1 ? (
            <></>
          ) : (
            <button onClick={() => addRoofQuote()}>
              {roofQuote.roofQuoteId
                ? "Update Roof Quote"
                : "Create Roof Quote"}
            </button>
          )}
          {reRoof > 0 && (
            <div style={{ marginTop: "1rem" }}>
              <button
                className="btn btn-danger"
                onClick={() => {
                  setReRoof(0);
                  setReRoofAmount("");
                  setView(false);
                }}
              >
                Remove Re-Roof
              </button>
            </div>
          )}
          <div>
            <UploadFile setFile={setRoofImg} />
          </div>
        </div>
      </Modal>
    </>
  );
};
export default ReRoofing;
